import React from 'react';

import { Checkbox, Flex, Tooltip } from 'antd-v5';
import { MdClose } from 'react-icons/md';
import { Text } from 'scouting-ui/lib';
import { cssVars } from 'scouting-ui/lib/variables';

import type { CounselorYouth } from '@appTypes/esb';
import { ConditionalRender, PersonAvatar } from '@shared/components';
import { getPreferredName } from '@shared/utils/preferredName';

import styles from './BulkMBCEntryPage.module.scss';

export const YouthItem: React.FC<{
  youth: CounselorYouth;
  checked: boolean;
  onSelect: (checked: boolean) => void;
  disabled?: boolean;
  errors?: string[];
}> = props => {
  const { youth, disabled, errors, checked, onSelect } = props;

  return (
    <Flex vertical align="flex-start" gap={4}>
      <Checkbox
        className={styles.youthCheckbox}
        disabled={disabled}
        checked={checked}
        onChange={item => {
          onSelect(item.target.checked);
        }}
      >
        <Flex align="center" gap="small">
          <PersonAvatar isAdult={false} gender={youth.gender} />
          <Text
            font="buttons-medium"
            color={disabled ? 'color-text-disabled' : 'color-info'}
          >
            {getPreferredName(youth)}
          </Text>
          <ConditionalRender value={!!errors?.length}>
            <Tooltip
              title={
                <ol className={styles.errorList}>
                  {errors?.map(error => (
                    <li key={error}>
                      <Text color="color-white" font="body-caption">
                        {error}
                      </Text>
                    </li>
                  ))}
                </ol>
              }
            >
              <MdClose
                className={styles.tagIcon}
                color={cssVars['color-error']}
              />
            </Tooltip>
          </ConditionalRender>
        </Flex>
      </Checkbox>
    </Flex>
  );
};
